module.exports = __webpack_public_path__ + "img/bean.e83753bc.gif";